module.exports = __webpack_public_path__ + "static/media/hvi-cover-img.76897bb0.jpg";